import { redirect } from '@tanstack/react-router';
import { getAuthToken, getAuthUser } from './auth-store';

/**
 * Quien ya tiene sesión no ve el formulario de login. Si lo viera, parecería
 * que el sistema lo sacó, y al entrar de nuevo abriría otra sesión mientras la
 * anterior sigue ocupando un cupo del máximo.
 */
export const redirectIfSignedIn = () => {
  if (getAuthToken() && getAuthUser()) {
    return redirect({ to: '/', replace: true });
  }
  return undefined;
};
